var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvertedcomma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 56,
    viewBox: "0 0 78 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.8799 29.3196V55.3578H0V32.7067C0 25.0152 0.596147 19.0525 1.78844 14.8185C2.98074 10.5847 5.5056 7.12701 9.36301 4.44557C13.2204 1.69355 18.7261 0.211694 25.8799 0V11.0081C17.4636 12.2782 13.2555 17.5353 13.2555 26.7792V29.3196H25.8799ZM77.8498 29.3196V55.3578H52.0752V32.7067C52.0752 25.0152 52.6363 19.0525 53.7584 14.8185C54.9508 10.5847 57.4756 7.12701 61.3331 4.44557C65.2606 1.69355 70.7662 0.211694 77.8498 0V11.0081C69.4336 12.2782 65.2254 17.5353 65.2254 26.7792C65.2254 27.3437 65.2606 28.1906 65.3307 29.3196H77.8498Z",
    fill: "#041446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedcomma);
export default __webpack_public_path__ + "static/media/invertedcomma.0c8cd78c8acbf54189d1a10c22e9dc55.svg";
export { ForwardRef as ReactComponent };